import axios, { CancelTokenSource } from 'axios'
import {
  IInboxFilters,
  IInboxPatchModel,
  IMessageRecipient,
} from 'Modules/Communication/shared/models/Inbox'
import { IPatchModel } from 'shared/models/Common'

const BASE_URL = 'inbox2/sms'
const MESSAGES_URL = `${BASE_URL}/messages`

export const getSmsMessages = (body: IInboxFilters) =>
  axios.post(`${MESSAGES_URL}/query`, body, {
    cancelToken: body.source?.token,
  })

export const getSms = (id: string, source?: CancelTokenSource) =>
  axios.get(`${MESSAGES_URL}/${id}`, {
    cancelToken: source?.token,
  })

export const createSms = (clientId: string, content: string) =>
  axios.post(`${MESSAGES_URL}`, {
    clientId,
    content,
  })

export const patchSmsById = (id: string, model: IPatchModel[]) =>
  axios.patch(`${MESSAGES_URL}/${id}`, model)

export const patchSms = (model: IInboxPatchModel) =>
  axios.patch(`${MESSAGES_URL}`, model)

export const updateSmsRecipients = (
  id: string,
  body: IPatchModel<IMessageRecipient[]>[]
) => axios.patch(`${MESSAGES_URL}/${id}/recipients`, body)

export const deleteSms = (id: string) => axios.delete(`${MESSAGES_URL}/${id}`)

export const deleteSmsList = (ids: string[]) =>
  axios.delete(`${MESSAGES_URL}`, { data: { messageIds: ids } })

export const sendSms = (messageId: string) =>
  axios.post(`${MESSAGES_URL}/${messageId}/send`)

export const getSmsSettings = (clientId: string) =>
  axios.get(`${BASE_URL}/settings/${clientId}`)

export const getSmsStatus = (clientId: string) =>
  axios.get(`${BASE_URL}/status/${clientId}`)

export const getSmsReciept = (messageId: string) =>
  axios.get(`${MESSAGES_URL}/${messageId}/receipt`)
